"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crossFetch = _interopRequireDefault(require("cross-fetch"));

// Dependency `cross-fetch` takes care of providing correct ponyfill for browsers,
// React Native and Node.js. See: https://github.com/lquixada/cross-fetch/blob/0b198e8f3a8dc7ebad8f973d4a5bce6d00719b8e/package.json#L6-L8
var _default = _crossFetch.default;
exports.default = _default;